import { render, staticRenderFns } from "./ServiceFormTemplate.vue?vue&type=template&id=4008373a"
import script from "./ServiceFormTemplate.vue?vue&type=script&lang=js"
export * from "./ServiceFormTemplate.vue?vue&type=script&lang=js"
import style0 from "./ServiceFormTemplate.vue?vue&type=style&index=0&id=4008373a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports